(() => {
  // Set the height of the container based on the image aspect ratio
  setContainerHeight();
  window.addEventListener("resize", setContainerHeight);
  // for collection slider
  carouselElement();
  // Updates hours of operation status
  updateStoreStatus({
    open: 9,
    close: 17,
    textContainer: document.getElementById("store-status"),
  });

  // FUNCTIONS
  function setContainerHeight() {
    const containers = document.querySelectorAll(".autoheight");

    containers.forEach((container) => {
      const image = container.querySelector("img");

      if (image) {
        const width = container.offsetWidth;
        const ratio = image.naturalHeight / image.naturalWidth;
        const height = width * ratio;

        container.style.height = `${height}px`;
      }
    });
  }
  window.addEventListener("resize", setContainerHeight);

  /**
   * Updates the store status based on the current time.
   * @param {Object} options - The options for updating the store status.
   * @param {number} options.open - The opening hour of the store.
   * @param {number} options.close - The closing hour of the store.
   * @param {HTMLElement} options.textContainer - The container element to display the store status.
   */
  function updateStoreStatus({ open, close, textContainer }) {
    if (!textContainer) return;
    function toPST(date) {
      const utc = date.getTime() + date.getTimezoneOffset() * 60000;
      return new Date(utc - 3600000 * 8);
    }

    const now = toPST(new Date());
    const day = now.getDay();
    const hours = now.getHours();

    if (day >= 1 && day <= 5) {
      if (hours < open) {
        textContainer.innerHTML =
          "Customer service is currently closed. Opens at 9:00 AM.";
      } else if (hours >= close) {
        textContainer.innerHTML =
          "Customer service is currently closed. Opens tomorrow at 9:00 AM.";
      } else {
        textContainer.innerHTML = "Customer service is currently open.";
      }
    } else {
      textContainer.innerHTML = "Customer service is closed today.";
    }
  }

  /* eslint-env browser */

  function carouselElement() {
    const slider = document.querySelector(".tws__slider");
    if (!slider) return;
    const slide = slider.querySelector(".tws__slide-list");
    const next = slider.querySelector(".pro-next");
    const prev = slider.querySelector(".pro-prev");
    const need_loop = document.querySelector(".tws__ctrl").hasAttribute("data-loop");
    const itemsWidth = 690;
    const itemsPerStep = 1;

    let currentSlide = 0;
    let totalSlides = slide.children.length;
    let totalItems = slide.children.length;

    function updateSlider() {
      slide.style.transform = `translateX(-${currentSlide * itemsWidth}px)`;

      // if not need loop, will hidden next and prev buttion when match condition
      if (!need_loop) {
        // Hide next button if in the last slide
        if (currentSlide === totalSlides - itemsPerStep) {
          next.style.display = "none";
        } else {
          next.style.display = "block";
        }
        // Hide prev button if in the first slide
        if (currentSlide === 0) {
          prev.style.display = "none";
        } else {
          prev.style.display = "block";
        }
      }
    }

    function nextSlide() {
      currentSlide += itemsPerStep;
      if (currentSlide > totalSlides - itemsPerStep) {
        if (need_loop) {
          currentSlide = 0;
        } else {
          currentSlide = totalSlides - itemsPerStep;
        }
      }

      updateSlider();
    }

    function prevSlide() {
      currentSlide -= itemsPerStep;
      if (currentSlide < 0) {
        if (need_loop){
          currentSlide = totalSlides - itemsPerStep;
        } else {
          currentSlide = 0;
        }
      }

      updateSlider();
    }

    next.addEventListener("click", nextSlide);
    prev.addEventListener("click", prevSlide);

    window.addEventListener("resize", () => {
      totalSlides = Math.ceil(totalItems / itemsPerStep);
      updateSlider();
    });

    updateSlider();
  }
  const imageOvrelayBtn = document.querySelectorAll(
    ".img-wrp .svg-wrp .imageOvrelaybtn"
  );
  if (imageOvrelayBtn != null) {
    // const imageOvrelayText = document.querySelectorAll('.img-wrp .image-ovrelayContent');
    imageOvrelayBtn.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const imageOvrelayText = button.closest(".img-wrp");
        // button.classList.remove("is--active");
        if (button.classList.contains("is--active")) {
          button.classList.remove("is--active");
          imageOvrelayText
            .querySelector(".image-ovrelayContent")
            .classList.remove("is--active");
        } else {
          // imageOvrelayBtn.classList.remove("is--active");
          button.classList.add("is--active");
          imageOvrelayText
            .querySelector(".image-ovrelayContent")
            .classList.add("is--active");
        }
      });
    });
  }
})();


document.addEventListener('DOMContentLoaded', function () {
   /**
   * V Filter Checklist - Interactive image switcher
   * Mobile: First item active by default
   * Desktop: No item active, shows default image
   */
   function initFilterChecklist() {
    const checklists = document.querySelectorAll('.v-filter-checklist');
    
    checklists.forEach(function(el) {
      const sectionId = el.getAttribute('data-section-id');
      const initKey = 'filter_checklist_init_' + sectionId;
      
      // Skip if already initialized
      if (window[initKey]) return;
      window[initKey] = true;
      
      const items = el.querySelectorAll('.v-filter-checklist__item');
      const images = el.querySelectorAll('.v-filter-checklist__image:not(.v-filter-checklist__image--default)');
      const defaultImage = el.querySelector('.v-filter-checklist__image--default');
      const listWrapper = el.querySelector('.v-filter-checklist__list-wrapper');
      
      /**
       * Switch to specific item
       * @param {number} index - Item index (-1 shows default image)
       */
      function switchItem(index) {
        // Remove active from all items and images
        items.forEach(function(item) {
          item.classList.remove('active');
        });
        images.forEach(function(img) {
          img.classList.remove('active');
        });
        
        if (index >= 0 && index < items.length) {
          // Activate specific item
          items[index].classList.add('active');
          images[index].classList.add('active');
          // Hide default image
          if (defaultImage) {
            defaultImage.classList.add('hidden');
          }
        } else {
          // Show default image
          if (defaultImage) {
            defaultImage.classList.remove('hidden');
          }
        }
      }
      
      /**
       * Reset to default state (show default image)
       */
      function resetToDefault() {
        switchItem(-1);
      }
      
      /**
       * Check if mobile viewport
       */
      function isMobile() {
        return window.innerWidth < 700;
      }
      
      // Add event listeners
      items.forEach(function(item) {
        const index = parseInt(item.getAttribute('data-index'));
        
        // Click for both mobile and desktop
        item.addEventListener('click', function(e) {
          e.preventDefault();
          switchItem(index);
        });
        
        // Hover for desktop only
        item.addEventListener('mouseenter', function() {
          if (!isMobile()) {
            switchItem(index);
          }
        });
      });
      
      // Mouse leave - reset to default on desktop
      if (listWrapper) {
        listWrapper.addEventListener('mouseleave', function() {
          if (!isMobile()) {
            resetToDefault();
          }
        });
      }
      
      // Initialize: Mobile shows first item, Desktop shows default image
      if (isMobile()) {
        switchItem(0);
      } else {
        resetToDefault();
      }
    });
  }
  
  // Initialize on load
  initFilterChecklist();
  
  // Shopify editor support
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      const section = document.querySelector('#shopify-section-' + e.detail.sectionId + ' .v-filter-checklist');
      if (section) {
        window['filter_checklist_init_' + e.detail.sectionId] = false;
        setTimeout(initFilterChecklist, 100);
      }
    });
  }
  /**
   * V Filter Checklist end
   */
})


/* Countdown module */
;(function() {
  'use strict'

  function clampToZero(n) { return n < 0 ? 0 : n }
  function pad2(n) { var v = Math.floor(clampToZero(n)); return v < 10 ? '0' + v : String(v) }
  function normalizeOffsetColon(tz) { return tz.replace(/([+-]\d{2})(\d{2})$/, '$1:$2') }
  function ensureIsoWithTz(input) {
    if (!input) return null
    var s = String(input).trim(); if (!s) return null
    s = s.replace(/\//g, '-'); s = s.replace(' ', 'T')
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) s += 'T00:00:00'
    if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(s)) s += '-04:00'; else s = s.replace(/([+-]\d{2})(\d{2})$/, normalizeOffsetColon('$1$2'))
    return s
  }

  function TimeCalculator() {}
  TimeCalculator.prototype.parse = function(input) {
    var iso = ensureIsoWithTz(input); if (!iso) return null
    var d = new Date(iso); if (isNaN(d.getTime())) return null
    return d
  }
  TimeCalculator.prototype.diff = function(target, now) {
    var ms = target.getTime() - now.getTime(); ms = Math.max(0, ms)
    var totalSeconds = Math.floor(ms / 1000)
    var days = Math.floor(totalSeconds / 86400)
    var hours = Math.floor((totalSeconds % 86400) / 3600)
    var minutes = Math.floor((totalSeconds % 3600) / 60)
    var seconds = totalSeconds % 60
    return { days: days, hours: hours, minutes: minutes, seconds: seconds, ms: ms }
  }

  function DOMUpdater(root) { this.root = root }
  DOMUpdater.prototype.setValues = function(values, leading) {
    var dd = this.root.querySelector('[data-dd]')
    var hh = this.root.querySelector('[data-hh]')
    var mm = this.root.querySelector('[data-mm]')
    var ss = this.root.querySelector('[data-ss]')

    function setIfChanged(el, nextText) {
      if (!el) return
      var text = String(nextText)
      if (el.textContent !== text) {
        el.textContent = text
      }
    }

    setIfChanged(dd, leading ? pad2(values.days) : String(values.days))
    setIfChanged(hh, leading ? pad2(values.hours) : String(values.hours))
    setIfChanged(mm, leading ? pad2(values.minutes) : String(values.minutes))
    setIfChanged(ss, leading ? pad2(values.seconds) : String(values.seconds))
  }
  DOMUpdater.prototype.showCompleteText = function(text) {
    this.root.innerHTML = '<span class="v-countdown__complete-text">' + (text || '') + '</span>'
  }
  DOMUpdater.prototype.hide = function() { this.root.style.display = 'none' }
  DOMUpdater.prototype.zero = function(leading) { this.setValues({ days: 0, hours: 0, minutes: 0, seconds: 0 }, leading) }

  function CountdownComponent(el, options) {
    this.el = el; this.options = options || {}
    this.tc = new TimeCalculator(); this.updater = new DOMUpdater(el)
    this._interval = null; this._target = null
  }
  CountdownComponent.prototype.init = function() {
    var targetStr = this.options.target || this.el.getAttribute('data-target') || ''
    var tzTarget = this.tc.parse(targetStr)
    if (!tzTarget) {
      var invalidText = this.options.invalidText || this.el.getAttribute('data-invalid-text') || 'Invalid date'
      this.el.innerHTML = invalidText; return false
    }
    this._target = tzTarget; this.render()
    var self = this; this._interval = setInterval(function() { self.render() }, 1000)
    return true
  }
  CountdownComponent.prototype.pause = function() { if (this._interval) { clearInterval(this._interval); this._interval = null } }
  CountdownComponent.prototype.resume = function() {
    var self = this; if (!this._target) return; if (this._interval) return
    this.render(); this._interval = setInterval(function() { self.render() }, 1000)
  }
  CountdownComponent.prototype.render = function() {
    var leading = this.options.leadingZero != null ? this.options.leadingZero : (this.el.getAttribute('data-leading-zero') === 'true')
    var behavior = this.options.completeBehavior || this.el.getAttribute('data-complete-behavior') || 'hide'
    var completeText = this.options.completeText || this.el.getAttribute('data-complete-text') || ''
    var diff = this.tc.diff(this._target, new Date())
    if (diff.ms <= 0) {
      this.destroy(); if (behavior === 'text' && completeText) this.updater.showCompleteText(completeText)
      else if (behavior === 'hide') this.updater.hide(); else this.updater.zero(leading); return
    }
    this.updater.setValues(diff, leading)
  }
  CountdownComponent.prototype.destroy = function() { if (this._interval) { clearInterval(this._interval); this._interval = null } }

  var Registry = (function() {
    var instances = new Set()
    function isManaged(el) { return !!(el.__vCc || el.__vCountdownInterval) }
    function attach(el) { if (!el || isManaged(el)) return null; var comp = new CountdownComponent(el, {}); if (!comp.init()) return null; el.__vCc = comp; instances.add(comp); return comp }
    function initAllIn(root) { var scope = root || document; var els = scope.querySelectorAll('[data-countdown]'); els.forEach(function(el){ attach(el) }) }
    function destroyAllIn(root) { var scope = root || document; var els = scope.querySelectorAll('[data-countdown]'); els.forEach(function(el){ if (el.__vCc) { el.__vCc.destroy(); instances.delete(el.__vCc); el.__vCc = null } }) }
    function pauseAll() { instances.forEach(function(c){ c.pause() }) }
    function resumeAll() { instances.forEach(function(c){ c.resume() }) }
    return { attach: attach, initAllIn: initAllIn, destroyAllIn: destroyAllIn, pauseAll: pauseAll, resumeAll: resumeAll }
  })()

  function onDomReady(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn() }
  onDomReady(function(){ if (window.VCountdownModule && window.VCountdownModule.autoInit === false) return; try { Registry.initAllIn(document) } catch (e) {} })
  document.addEventListener('visibilitychange', function(){ try { if (document.hidden) Registry.pauseAll(); else Registry.resumeAll() } catch (e) {} })
  window.addEventListener('beforeunload', function(){ try { Registry.destroyAllIn(document) } catch (e) {} })
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e){ try { if (!e || !e.detail || !e.detail.sectionId) return; var root = document.getElementById('shopify-section-' + e.detail.sectionId); if (root) Registry.initAllIn(root) } catch (err) {} })
    document.addEventListener('shopify:section:unload', function(e){ try { if (!e || !e.detail || !e.detail.sectionId) return; var root = document.getElementById('shopify-section-' + e.detail.sectionId); if (root) Registry.destroyAllIn(root) } catch (err) {} })
  }

  window.VCountdownModule = { TimeCalculator: TimeCalculator, DOMUpdater: DOMUpdater, CountdownComponent: CountdownComponent, Registry: Registry, autoInit: true }
})()

/* Anchor navigation module */
;(function(){
  'use strict'

  function qsa(scope, sel){ return Array.prototype.slice.call((scope||document).querySelectorAll(sel)) }
  function on(el, type, handler){ if (el) el.addEventListener(type, handler, { passive: true }) }

  function getStickyOffset(nav){
    try {
      if (nav.getAttribute('data-sticky') !== 'true') return 0
      var top = getComputedStyle(nav).top
      var n = parseInt(top, 10)
      return isNaN(n) ? 0 : n
    } catch(e){ return 0 }
  }

  function smoothScrollTo(y){
    try { window.scrollTo({ top: y, behavior: 'smooth' }) }
    catch(e){ window.scrollTo(0, y) }
  }

  function scrollToId(id, offset){
    var el = document.getElementById(id)
    if (!el) return false
    var rect = el.getBoundingClientRect()
    var extraOffset = 0
    try {
      var computed = getComputedStyle(el)
      var scrollMarginTop = computed.scrollMarginTop
      if (scrollMarginTop && scrollMarginTop !== 'auto') {
        var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0
        var totalMargin = parseFloat(scrollMarginTop)
        extraOffset = totalMargin - headerHeight
      }
    } catch(e) {}
    var top = rect.top + window.pageYOffset - (offset || 0) - extraOffset
    smoothScrollTo(top)
    return true
  }

  function initAnchorNav(root){
    var container = root || document
    var navs = qsa(container, '.v-anchor-navigation')
    if (!navs.length) return

    navs.forEach(function(nav){
      if (nav.__vAnchorInit) return; nav.__vAnchorInit = true

      var smooth = String(nav.getAttribute('data-smooth')) === 'true'
      var links = qsa(nav, '.v-anchor-navigation__link')
      if (!links.length) return

      var stickyTop = getStickyOffset(nav)

      // clicks
      var lockTargetId = null
      function unlockWhenArrived(targetEl){
        if (!targetEl) { lockTargetId = null; return }
        var tries = 0
        ;(function tick(){
          var expected = getDocTop(targetEl) - stickyTop
          var at = Math.abs(window.pageYOffset - expected) <= 2
          if (at || tries > 300) { lockTargetId = null; recomputeActiveByScroll(); return }
          tries++; requestAnimationFrame(tick)
        })()
      }

      links.forEach(function(a){
        a.addEventListener('click', function(e){
          var id = a.getAttribute('data-anchor') || ''
          if (!id) return
          if (smooth) e.preventDefault()
          var ok = scrollToId(id, stickyTop)
          if (smooth && ok) { lockTargetId = id; setActive(id); unlockWhenArrived(document.getElementById(id)) }
          // Do not modify URL hash when smooth scrolling is enabled
        }, { passive: false })
      })

      // active state
      var activeClass = 'is-active'
      function setActive(id){
        var activeLink = null
        links.forEach(function(a){
          var isActive = id && (a.getAttribute('data-anchor') === id)
          a.classList.toggle(activeClass, isActive)
          if (isActive) {
            a.setAttribute('aria-current', 'location')
            activeLink = a
          } else {
            a.removeAttribute('aria-current')
          }
        })
        
        // Center active item when navigation has overflow
        if (activeLink && list && list.scrollWidth > list.clientWidth) {
          scrollActiveToCenter(activeLink)
        }
      }

      // Scroll active item to center of navigation
      function scrollActiveToCenter(activeLink) {
        if (!activeLink || !list) return
        
        var linkRect = activeLink.getBoundingClientRect()
        var listRect = list.getBoundingClientRect()
        
        // Calculate the position of the link relative to the list container
        var linkCenterX = linkRect.left + linkRect.width / 2 - listRect.left + list.scrollLeft
        var listCenterX = list.clientWidth / 2
        
        // Calculate target scroll position to center the active item
        var targetScrollLeft = linkCenterX - listCenterX
        
        // Clamp to valid scroll range
        targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, list.scrollWidth - list.clientWidth))
        
        // Smooth scroll to target position
        list.scrollTo({ left: targetScrollLeft, behavior: 'smooth' })
      }

      var targets = links.map(function(a){ var id = a.getAttribute('data-anchor'); return id ? document.getElementById(id) : null }).filter(Boolean)
      function getDocTop(el){ try { var r = el.getBoundingClientRect(); return r.top + window.pageYOffset } catch(e){ return 0 } }

      function recomputeActiveByScroll(){
        if (lockTargetId) { setActive(lockTargetId); return }
        if (!targets.length) { setActive(null); return }
        var viewport = window.innerHeight || document.documentElement.clientHeight || 0
        var lineY = window.scrollY + stickyTop + Math.min(viewport * 0.25, 200)
        // sort defensively (in case DOM order changes)
        var ordered = targets.slice().sort(function(a,b){ return getDocTop(a) - getDocTop(b) })
        var current = null
        for (var i=0;i<ordered.length;i++){
          if (getDocTop(ordered[i]) <= lineY) current = ordered[i]; else break
        }
        // If near the very bottom, force last as active
        var scrollBottom = window.scrollY + viewport
        var docHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
        if (!current && (docHeight - scrollBottom) <= 2) current = ordered[ordered.length - 1]
        if (current) setActive(current.id); else setActive(null)
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){ if (!lockTargetId && entry.isIntersecting) setActive(entry.target.id) })
        }, { root: null, rootMargin: '0px 0px -60% 0px', threshold: 0.1 })
        targets.forEach(function(t){ io.observe(t) })
        // Always reconcile by scroll position to handle the zone above first target
        on(window, 'scroll', recomputeActiveByScroll)
        on(window, 'resize', recomputeActiveByScroll)
        recomputeActiveByScroll()
      } else {
        var ticking = false
        function onScroll(){
          if (ticking) return; ticking = true
          requestAnimationFrame(function(){
            recomputeActiveByScroll()
            ticking = false
          })
        }
        on(window, 'scroll', onScroll)
        on(window, 'resize', onScroll)
        onScroll()
      }

      // scroll arrows
      var list = nav.querySelector('.v-anchor-navigation__list')
      var prevBtn = nav.querySelector('[data-arrow="prev"]')
      var nextBtn = nav.querySelector('[data-arrow="next"]')
      if (list && prevBtn && nextBtn) {
        function updateArrows(){
          try {
            var canScrollLeft = list.scrollLeft > 0
            var canScrollRight = Math.ceil(list.scrollLeft + list.clientWidth) < list.scrollWidth
            var hasOverflow = list.scrollWidth > list.clientWidth
            prevBtn.hidden = !canScrollLeft
            nextBtn.hidden = !canScrollRight
            nav.classList.toggle('has-scroll-arrows', (canScrollLeft || canScrollRight))
            list.classList.toggle('has-overflow', hasOverflow)
            
            // Reset scroll position to start when overflow is detected and centered
            if (hasOverflow && list.scrollLeft === 0 && getComputedStyle(list).justifyContent === 'center') {
              setTimeout(function() { list.scrollLeft = 0 }, 0)
            }
          } catch(e) {}
        }
        function scrollByAmount(dir){
          var amount = Math.max(120, Math.floor(list.clientWidth * 0.6))
          var to = dir === 'next' ? (list.scrollLeft + amount) : (list.scrollLeft - amount)
          list.scrollTo({ left: to, behavior: 'smooth' })
        }
        prevBtn.addEventListener('click', function(){ scrollByAmount('prev') })
        nextBtn.addEventListener('click', function(){ scrollByAmount('next') })
        list.addEventListener('scroll', updateArrows, { passive: true })
        window.addEventListener('resize', updateArrows)
        // Initial check and ensure proper scroll position
        setTimeout(function() {
          updateArrows()
          // Force scroll to start if has overflow and centered
          if (list.scrollWidth > list.clientWidth) {
            list.scrollLeft = 0
          }
        }, 0)
      }

      // initial hash
      if (location.hash && location.hash.length > 1){
        var initialId = location.hash.slice(1)
        setTimeout(function(){ 
          scrollToId(initialId, stickyTop)
          setActive(initialId)
        }, 0)
      }

      // back/forward
      window.addEventListener('popstate', function(){
        var id = (location.hash || '').replace(/^#/, '')
        if (!id) return
        scrollToId(id, stickyTop)
        setActive(id)
      })
    })
  }

  function onReady(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn() }
  onReady(function(){ try { initAnchorNav(document) } catch(e){} })

  if (window.Shopify && Shopify.designMode){
    document.addEventListener('shopify:section:load', function(e){
      try {
        if (!e || !e.detail || !e.detail.sectionId) return
        var root = document.getElementById('shopify-section-' + e.detail.sectionId)
        if (root) initAnchorNav(root)
      } catch(err){}
    })
  }
})()
